﻿import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import Form from '../../../../vendor/react-validation/components/form';
import ValidationButton from '../../../Forms/Components/ValidationButton';
import TextInput from '../../../Forms/Components/TextInput';

import getFormValues from '../../../Forms/getFormValues';
import { getEpiData } from '../../../Utils/epiHelpers';
import { required, validPersonalIdentityOrCoordinationNo, ownPersonalIdNumberNotSuppliedForCoinsuree } from '../../../Forms/Validation/rules';
import { submitCoInsuredFormAction, fetchCustomerInfo } from '../State/actions';


class CoInsuredForm extends React.Component {

    static get propTypes() {
        return {
            mountRootId: PropTypes.string.isRequired
        }
    }

    constructor(props) {
        super(props);
        this.pageRedirect = getEpiData('url', this.props.mountRootId) || '';
    }

    componentDidMount() {
        this.props.loadData();
    }

    submitForm = (e) => {
        e.preventDefault();
        const url = this.pageRedirect;
        const formValues = getFormValues(this.form);
        this.props.submitCoInsuredForm({ url, ...formValues });
    }

    render() {
        let error = this.props.data.formSubmitFailed;
        const memberPersonalId = this.props.data.personalIdentityNumber;

        // variables for hiding content on surrounding view, if error
        const headline = document.querySelector('[js-campaign-title]');
        const preamble = document.querySelector('[js-campaign-preamble]');
        const subtext = document.querySelector('[js-campaign-subtext]');

            let content = (
                <div className="coinsured-form-block">
                    <h2 className="coinsured-form-block__headline">Uppgifter om medförsäkrad</h2>
                    <Form ref={el => { this.form = el; }}
                        onSubmit={e => this.submitForm(e)}>

                        <div className="coinsured-form-block__header">
                            <div className="coinsured-form-block__header__text">
                                <h3 className="coinsured-form-block__header__label">Förnamn</h3>
                                <TextInput
                                    placeholder="Förnamn"
                                    id="CoinsuredFirstName"
                                    name="CoinsuredFirstName"
                                    data-validation-error-message="Du måste ange medförsäkrads förnamn"
                                    validations={[
                                        required
                                    ]}
                                />
                            </div>

                            <div className="coinsured-form-block__header__text">
                                <h3 className="coinsured-form-block__header__label">Efternamn</h3>
                                <TextInput
                                    required
                                    placeholder="Efternamn"
                                    id="CoinsuredLastName"
                                    name="CoinsuredLastName"
                                    data-validation-error-message="Du måste ange medförsäkrads efternamn"
                                    validations={[
                                        required
                                    ]}
                                />
                            </div>
                        </div>

                        <div className="coinsured-form-block__number">
                            <h3 className="coinsured-form-block__label">Person- eller samordningsnummer</h3>
                            <TextInput
                                required
                                placeholder="YYYYMMMDDXXXX"
                                id="CoinsuredPersonalIdentityNumber"
                                name="CoinsuredPersonalIdentityNumber"
                                data-validation-error-message="Du måste ange ett giltigt person- eller samordningsnummer"
                                validations={[
                                    validPersonalIdentityOrCoordinationNo,
                                    ownPersonalIdNumberNotSuppliedForCoinsuree(memberPersonalId)
                                ]}
                            />
                        </div>
                        <div className="coinsured-form-block__button__container">
                            <ValidationButton noIcon>
                                Skicka in uppgifterna
                        </ValidationButton>
                        </div>

                    </Form>
                </div>
            )
        if (error) {
            headline.style.display = "none";
            preamble.style.display = "none";
            subtext.style.display = "none";

                content = (
                    <div className="coinsured-form-block__error">Åh nej!
                    Något blev tyvärr fel. <br />
                    Kontakta kundservice på <span><a href="callto:0771-21 09 09">0771-21 09 09 </a></span> (öppet vardagar 9-17) så hjälper vi dig vidare. 
                    </div>
                )
            }
         
        return (
            <React.Fragment>{content}</React.Fragment>
        );
    }
}

// state

const mapStateToProps = (state) => {
    return {
        payload: state.customerInfo,
        data: state.coInsuredFormData,
        hasErrored: state.pageHasErrored,
        error: state.pageError,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadData: (payload) => dispatch(fetchCustomerInfo(payload)),
        submitCoInsuredForm: (data) => dispatch(submitCoInsuredFormAction(data)),
        formSubmitFailed: (data) => dispatch(submitFormSubmitFailedAction(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CoInsuredForm);

